// @ts-nocheck
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { checkoutBackLinkStyles } from "@store/Themes/common/mixins/checkout";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCartState(state, state.pages.orderConfirmation.cartId);
    const currentCartState = getCurrentCartState(state);

    return {
        cartState,
        cartPageUrl: getPageLinkByPageType(state, "CartPage")?.url,
        linkedCartState:
            cartState.value && cartState.value.properties.linkedCarts
                ? getCartState(state, cartState.value.properties.linkedCarts)
                : null,
        currentCartState,
    };
};

export interface OrderConfirmationErrorMessageStyles {
    warningIcon?: IconPresentationProps;
    warningSection?: InjectableCss;
    warningText?: TypographyPresentationProps;
    continueShoppingLink?: LinkPresentationProps;
}

export const orderConfirmationErrorMessageStyles: OrderConfirmationErrorMessageStyles = {
    warningIcon: {
        src: "AlertCircle",
        color: "danger.main",
        css: css`
            margin-right: ${pxToRem(10)};
        `,
    },
    warningSection: {
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: ${pxToRem(32)};
            border: 2px solid ${getColor("danger.main")};
            padding: ${pxToRem(15, 10)};
            width: 100%;
        `,
    },
    continueShoppingLink: checkoutBackLinkStyles,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const StyledSection = getStyledWrapper("section");

const styles = orderConfirmationErrorMessageStyles;
const OrderConfirmationErrorMessage = ({ cartState, cartPageUrl, linkedCartState, currentCartState }: Props) => {
    const cart = cartState.value;
    const linkedCart = linkedCartState?.value;
    const currentCart = currentCartState.value;

    if (!cart && !linkedCart && !currentCart) {
        return null;
    }

    const programItemError =
        cart?.properties.programItemsErrorMessage ||
        linkedCart?.properties.programItemsErrorMessage ||
        currentCart?.properties.programItemsErrorMessage;

    const error = cart?.properties.submitError || programItemError;

    return (
        <>
            {cart?.properties.submitError && (
                <StyledSection {...styles.warningSection}>
                    <Icon {...styles.warningIcon}></Icon>
                    <Typography {...styles.warningText}>{translate("brs_orderSubmitError")}</Typography>
                </StyledSection>
            )}
            {programItemError && (
                <StyledSection {...styles.warningSection}>
                    <Icon {...styles.warningIcon}></Icon>
                    <Typography {...styles.warningText}>{programItemError}</Typography>
                </StyledSection>
            )}
            {error && (
                <Link {...styles.continueShoppingLink} href={cartPageUrl}>
                    {translate("Back to cart")}
                </Link>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderConfirmationErrorMessage),
    definition: {
        displayName: "Order Confirmation Error Message",
        icon: "cart-circle-check",
        group: "Order Confirmation",
    },
};

export default widgetModule;
